import {
  type NodeKind,
  type Section,
  useSidebarTreeStore,
} from '../../../../store/storeSidebarTree';
import type { DragData, DropData, DropPosition } from './types';

export type BackendNodeKind = 'folder' | 'flow' | 'form' | 'object' | 'vector';

export const normalizeBackendKind = (kind: NodeKind): BackendNodeKind => {
  if (kind === 'agent' || kind === 'fluxbot') return 'flow';
  return kind;
};

export const nodeKindOf = (drag: DragData): NodeKind => drag.kind;

export const activeIdOf = (drag: DragData): string =>
  drag.kind === 'folder' ? drag.folderId : drag.itemId;

export interface MoveTarget {
  parentId: string | null;
  section: Section;
  spaceId: string | null;
}

export const resolveTarget = (
  over: DropData,
  active: DragData,
  position: DropPosition | null,
): MoveTarget | null => {
  const state = useSidebarTreeStore.getState();

  if (over.kind === 'root-drop') {
    return {
      parentId: null,
      section: over.section,
      spaceId: over.spaceId,
    };
  }

  if (over.kind === 'folder-drop') {
    const target = state.nodes[over.folderId];
    const isReorder = position === 'above' || position === 'below';
    const activeNode = state.nodes[activeIdOf(active)];

    if (target) {
      if (isReorder) {
        return {
          parentId: target.parentId,
          section: target.section,
          spaceId: target.spaceId,
        };
      }
      return {
        parentId: target.id,
        section: target.section,
        spaceId: target.spaceId,
      };
    }
    return {
      parentId: isReorder ? over.parentId : over.folderId,
      section: activeNode?.section ?? 'agents',
      spaceId: over.spaceId,
    };
  }

  const targetItem = state.nodes[over.itemId];
  const parentId = over.parentId;
  if (parentId) {
    const parentNode = state.nodes[parentId];
    return {
      parentId,
      section: parentNode?.section ?? targetItem?.section ?? 'agents',
      spaceId: parentNode?.spaceId ?? targetItem?.spaceId ?? over.spaceId,
    };
  }
  if (targetItem) {
    return {
      parentId: targetItem.parentId,
      section: targetItem.section,
      spaceId: targetItem.spaceId,
    };
  }
  return null;
};
